/*
 *
 * Groups constants
 *
 */
export var LOAD_GROUPS_REQUEST = 'app/Groups/LOAD_GROUPS_REQUEST';
export var LOAD_GROUPS_SUCCESS = 'app/Groups/LOAD_GROUPS_SUCCESS';
export var LOAD_GROUPS_FAILURE = 'app/Groups/LOAD_GROUPS_FAILURE';
